import {engineContext} from './context.js';

(function(g){'use strict';
const VERSION='0.1.0-alpha';
const cp=x=>x==null?x:JSON.parse(JSON.stringify(x));

function create(opts={}){
 const readiness=opts.readiness;
 const bootstrap=opts.bootstrap;
 const batch=opts.batch;
 const containment=opts.containment;
 if(!readiness||typeof readiness.bootstrapReport!=='function') throw Error('READINESS_REQUIRED');

 async function start(config={}){
   const report=readiness.bootstrapReport(config.root||g);
   if(report.status==='BLOCK'){
     return Object.freeze({version:VERSION,status:'BLOCK',stage:'CAPABILITY_CHECK',readiness:cp(report),restore:null,batch:null});
   }

   let restore=null;
   if(config.symbol && bootstrap && typeof bootstrap.bootstrap==='function'){
     try{
       restore=await bootstrap.bootstrap(config.symbol,config.scope||'RESEARCH',config.targets||{});
       if(restore.status==='REVIEW'){
         return Object.freeze({version:VERSION,status:'REVIEW',stage:'RESTORE',readiness:cp(report),restore:cp(restore),batch:null});
       }
     }catch(e){
       return Object.freeze({version:VERSION,status:'REVIEW',stage:'RESTORE',readiness:cp(report),restore:null,error:String(e&&e.message||e),batch:null});
     }
   }

   return Object.freeze({version:VERSION,status:report.status==='REVIEW'?'REVIEW':'READY',stage:'SESSION_READY',readiness:cp(report),restore:cp(restore),batch:null});
 }

 async function runResearchSession(config={}){
   const session=await start(config);
   if(session.status==='BLOCK'||session.stage==='RESTORE') return session;
   if(!batch||typeof batch.runBatch!=='function'){
     return Object.freeze({...cp(session),status:'REVIEW',stage:'BATCH',error:'BATCH_REQUIRED'});
   }

   try{
     const result=await batch.runBatch(config.items||[],config.budgetMinutes||60);
     let status=session.status==='REVIEW'?'REVIEW':'READY';

     if(result.summary && result.summary.reviewCount>0) status='REVIEW';

     if(containment && typeof containment.contain==='function'){
       const issues=[];
       for(const r of result.results||[]){
         if(r.status!=='READY') issues.push({type:'ENGINE_ERROR',source:r.symbol,required:false});
       }
       const c=containment.contain({issues});
       if(c.status==='BLOCK'||c.status==='REVIEW') status='REVIEW';
     }

     return Object.freeze({
       version:VERSION,status,stage:'COMPLETE',
       readiness:cp(session.readiness),
       restore:cp(session.restore),
       batch:cp(result)
     });
   }catch(e){
     return Object.freeze({...cp(session),status:'REVIEW',stage:'BATCH',error:String(e&&e.message||e)});
   }
 }

 return Object.freeze({VERSION,start,runResearchSession});
}

async function selfTest(){
 const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});

 const ready={bootstrapReport:()=>({status:'READY',readyCount:8})};
 const block={bootstrapReport:()=>({status:'BLOCK',missingCount:1})};
 const review={bootstrapReport:()=>({status:'REVIEW',reviewCount:1})};

 const c1=create({readiness:block});
 const s1=await c1.start({});
 ok('blocked capabilities stop session',s1.status==='BLOCK'&&s1.stage==='CAPABILITY_CHECK');

 const c2=create({readiness:ready});
 const s2=await c2.start({});
 ok('ready capabilities start session',s2.status==='READY'&&s2.stage==='SESSION_READY');

 const c3=create({readiness:review});
 const s3=await c3.start({});
 ok('capability review propagates',s3.status==='REVIEW');

 const boot={bootstrap:async()=>({status:'READY',restored:{}})};
 const c4=create({readiness:ready,bootstrap:boot});
 const s4=await c4.start({symbol:'AAA',scope:'OWNED'});
 ok('bootstrap restore can complete',s4.status==='READY'&&s4.restore.status==='READY');

 const badBoot={bootstrap:async()=>({status:'REVIEW'})};
 const c5=create({readiness:ready,bootstrap:badBoot});
 const s5=await c5.start({symbol:'AAA'});
 ok('restore review stops before batch',s5.status==='REVIEW'&&s5.stage==='RESTORE');

 const batch={runBatch:async(items,budget)=>({results:items.map(x=>({symbol:x.symbol,status:'READY'})),summary:{selectedCount:items.length,reviewCount:0,budgetMinutes:budget}})};
 const c6=create({readiness:ready,batch});
 const rs=await c6.runResearchSession({items:[{symbol:'AAA'},{symbol:'BBB'}],budgetMinutes:30});
 ok('full research session completes',rs.status==='READY'&&rs.stage==='COMPLETE');
 ok('batch receives items',rs.batch.summary.selectedCount===2);
 ok('budget propagated',rs.batch.summary.budgetMinutes===30);

 const batchReview={runBatch:async()=>({results:[{symbol:'AAA',status:'REVIEW'}],summary:{selectedCount:1,reviewCount:1}})};
 const c7=create({readiness:ready,batch:batchReview});
 const rr=await c7.runResearchSession({items:[{symbol:'AAA'}]});
 ok('company review propagates to session',rr.status==='REVIEW');

 const containment={contain:({issues})=>({status:issues.length?'REVIEW':'READY'})};
 const c8=create({readiness:ready,batch:batchReview,containment});
 const cr=await c8.runResearchSession({items:[{symbol:'AAA'}]});
 ok('containment participates in session',cr.status==='REVIEW');

 const c9=create({readiness:ready});
 const nb=await c9.runResearchSession({});
 ok('missing batch returns review',nb.status==='REVIEW'&&nb.error==='BATCH_REQUIRED');

 const failBatch={runBatch:async()=>{throw Error('BATCH_FAIL')}};
 const c10=create({readiness:ready,batch:failBatch});
 const fb=await c10.runResearchSession({});
 ok('batch exception contained',fb.status==='REVIEW'&&fb.error==='BATCH_FAIL');

 let er=false;try{create({})}catch(e){er=e.message==='READINESS_REQUIRED'}
 ok('readiness required',er);

 const api=create({readiness:ready,batch});
 ok('no trade signal',!('tradeSignal' in api));
 ok('no capital permission',!('capitalPermission' in api));
 ok('no universal score',!('score' in api));

 return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}

g.ZooInvestRuntimeSessionCoordinator=Object.freeze({VERSION,create,selfTest});
})(engineContext);